import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-lock-03',
  imports: [],
  templateUrl: './lock-03.html',
  styleUrl: './lock-03.scss',
})
export class Lock03 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
